<!-- 払いもどし画面の料金表示 -->
<template>
  <div class="row">
    <!-- 表記は購入額としているが、内部的には払い戻し金額 -->
    <div class="th cell">購入額</div>
    <div class="cell price">{{ price.toLocaleString() }}円</div>
  </div>

  <div class="row">
    <div class="th cell">手数料</div>
    <div class="cell price">-{{ refundFee.toLocaleString() }}円</div>
  </div>

  <hr class="hr" />

  <div class="row">
    <!-- 払い戻し金額 - 払い戻し手数料 = 返金額 -->
    <div class="th cell">返金額</div>
    <div class="cell price">{{ (price - refundFee).toLocaleString() }}円</div>
  </div>
</template>

<script>
export default {
  name: "MFITTRefundPrices",
  props: {
    price: {
      type: Number,
      required: true,
    },
    refundFee: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: table-row;
}
.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 60vw;
  color: grey;
}
.price {
  text-align: right;
}
</style>
